// extracted by mini-css-extract-plugin
module.exports = {"movie-details-container":"MovieDetails_movie-details-container__1pTXl"};